import React from 'react';
import CheckIcon from 'react-icons/lib/md/check-circle';

const ManifestDeleteSuccess = ({manifestDeleteResponse}) => {
    return (
        <div className={'text-center'}>
            <CheckIcon size="70" color="#60982d"/>
            <h5 className="text-center mt-2">
                {manifestDeleteResponse}
            </h5>
        </div>
    );
};

export default ManifestDeleteSuccess;


// WEBPACK FOOTER //
// ./src/views/search/successful-manifest-delete.js